<div class="form-wrapper">
  <div class="form-content size size1of1">
    <div [formGroup]="form" class="form-block">
      <!-- Type -->
      <div class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
          <mat-label>Type</mat-label>
          <mat-select (selectionChange)="onChangeChargeType($event.value)" formControlName="chargeType" required disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option *ngFor="let chargeType of collectionOfChargeType" [disabled]="chargeType?.value === _chargeType.usageCharge" [value]="chargeType?.value" class="custom-mat-option">{{ chargeType.label }}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('chargeType')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <!-- Custom Billing Period -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge ? 'block' : 'none'" class="form-row row-flex-wrap">
        <mat-form-field class="custom-mat-form-field size size1of1 md-size1of2">
          <mat-label>Frequency Unit</mat-label>
          <mat-select (selectionChange)="onChangeFrequencyUnit($event)" class="custom-mat-select" formControlName="billingPeriod">
            <mat-option *ngFor="let frequencyUnit of collectionOfFrequencyUnit" [value]="frequencyUnit?.value" class="custom-mat-option">{{frequencyUnit?.label}}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('billingPeriod')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field class="custom-mat-form-field size size1of1 md-size1of2">
          <mat-label>Frequency Length</mat-label>
          <input matInput type="text" formControlName="specificBillingPeriod" [cleave]="cleaveNumIntegerOptions">
          <mat-error><error-messages [control]="form.get('specificBillingPeriod')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <!-- Billing Day -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge ? 'block' : 'none'" class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
          <mat-label>Billing Day</mat-label>
          <mat-select (selectionChange)="onChangeBillCycleType($event.value)" formControlName="billCycleType" disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option *ngFor="let billCycleType of collectionOfBillCycleType" [value]="billCycleType?.value" class="custom-mat-option">{{ billCycleType?.label }}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('billCycleType')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <!-- Custom Billing Day of a Week -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge && selectedBillCycleType === _billCycleTypeValues.specificDayOfWeek ? 'block' : 'none'" class="form-row row-calendar-week-days">
        <div class="form-row-inner">
          <mat-button-toggle-group formControlName="weeklyBillCycleDay" multiple="false" class="custom-mat-button-toggle-group">
            <mat-button-toggle value="sunday" class="custom-mat-button-toggle"><span>Sunday</span></mat-button-toggle>
            <mat-button-toggle value="monday" class="custom-mat-button-toggle"><span>Monday</span></mat-button-toggle>
            <mat-button-toggle value="tuesday" class="custom-mat-button-toggle"><span>Tuesday</span></mat-button-toggle>
            <mat-button-toggle value="wednesday" class="custom-mat-button-toggle"><span>Wednesday</span></mat-button-toggle>
            <mat-button-toggle value="thursday" class="custom-mat-button-toggle"><span>Thursday</span></mat-button-toggle>
            <mat-button-toggle value="friday" class="custom-mat-button-toggle"><span>Friday</span></mat-button-toggle>
            <mat-button-toggle value="saturday" class="custom-mat-button-toggle"><span>Saturday</span></mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <!-- Custom Billing Day of a Month -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge && selectedBillCycleType === _billCycleTypeValues.specificDayOfMonth ? 'block' : 'none'" class="form-row row-calendar-days">
        <div class="form-row-inner">
          <mat-button-toggle-group formControlName="billCycleDay" multiple="false" class="custom-mat-button-toggle-group group-calendar-days">
            <mat-button-toggle disableRipple="true" *ngFor="let day of collectionOfMonthDay" [value]="day" class="custom-mat-button-toggle rounded">{{day}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <!-- Custom Billing Day of a Year -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge && selectedBillCycleType === _billCycleTypeValues.specificMonthOfYear ? 'block' : 'none'" class="form-row row-calendar-week-days">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of2">
          <mat-label>Month</mat-label>
          <mat-select disableOptionCentering="true" formControlName="monthlyBillCycleYear" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option value="1" class="custom-mat-option">January</mat-option>
            <mat-option value="2" class="custom-mat-option">February</mat-option>
            <mat-option value="3" class="custom-mat-option">March</mat-option>
            <mat-option value="4" class="custom-mat-option">April</mat-option>
            <mat-option value="5" class="custom-mat-option">May</mat-option>
            <mat-option value="6" class="custom-mat-option">June</mat-option>
            <mat-option value="7" class="custom-mat-option">July</mat-option>
            <mat-option value="8" class="custom-mat-option">August</mat-option>
            <mat-option value="9" class="custom-mat-option">September</mat-option>
            <mat-option value="10" class="custom-mat-option">October</mat-option>
            <mat-option value="11" class="custom-mat-option">November</mat-option>
            <mat-option value="12" class="custom-mat-option">December</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('monthlyBillCycleYear')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of2">
          <mat-label>Day</mat-label>
          <input matInput type="text" formControlName="billCycleDay" [cleave]="cleaveNumIntegerOptions">
          <mat-error><error-messages [control]="form.get('billCycleDay')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <!-- Billing Timming -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge ? 'block' : 'none'" class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
          <mat-label>Billing Timing</mat-label>
          <mat-select formControlName="billingTiming" disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option *ngFor="let billingTiming of collectionOfBillingTiming" [value]="billingTiming.value" class="custom-mat-option">{{ billingTiming.label }}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('billingTiming')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <!-- Billing Period Alignment -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge ? 'block' : 'none'" class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
          <mat-label>Billing Period Alignment</mat-label>
          <mat-select formControlName="billingPeriodAlignment" disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option *ngFor="let billingPeriodAlignment of collectionOfBillingPeriodAlignment" [value]="billingPeriodAlignment.value" [disabled]="billingPeriodAlignment.status === _statusValues.disabled" class="custom-mat-option">{{ billingPeriodAlignment.label }}
            </mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('billingPeriodAlignment')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <!-- Starting Date -->
      <div class="form-row">
        <mat-form-field class="custom-mat-form-field field-starting-date size size1of1">
          <mat-label>Starting Date</mat-label>
          <mat-select (selectionChange)="onChangeStartingDateOption($event.value)" [(value)]="selectedStartingDateOption" class="custom-mat-select" [disabled]="ratePlanCharge?.processedThroughDate || ('view_sub_startdate|enabled|SCOPE_SET_VALUE' | appRestriction)">
            <mat-option *ngFor="let term of collectionOfChargeStartingDateOptions" [value]="term.value" class="custom-mat-option">{{ term.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- MOSTRAR ESTA ROW EN CASO DE QUE EL STARTING DATE SEA SCHEDULE -->
      <div *ngIf="selectedStartingDateOption === _chargeStartingDateOptions.schedule || selectedStartingDateOption === _chargeStartingDateOptions.subscriptionFreeTrial" class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of2">
          <mat-label>Type</mat-label>
          <mat-select formControlName="delayType" required disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select" (selectionChange)="onChangeDelayType($event)">
            <mat-option *ngFor="let delayType of collectionOfUpToPeriodsType" [value]="delayType.value" class="custom-mat-option">{{ delayType.label }}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('delayType')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of2">
          <mat-label>Length</mat-label>
          <input matInput type="text" formControlName="delay" required placeholder="1" [cleave]="cleaveNumIntegerOptions">
          <mat-error><error-messages [control]="form.get('delay')"></error-messages></mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="selectedStartingDateOption === _chargeStartingDateOptions.custom" class="form-row">
        <mat-form-field class="custom-mat-form-field field-date-picker">
          <mat-label>{{isSubscription ? 'Next Charge Date' : 'Starting Date'}}</mat-label>
          <input matInput formControlName="startingDate" [matDatepicker]="startingDate" [min]="minStartingDate" readonly panelClass="custom-mat-datepicker-panel">
          <mat-datepicker-toggle matSuffix [for]="startingDate" class="custom-mat-datepicker-toggle"></mat-datepicker-toggle>
          <mat-datepicker #startingDate></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Billing Date End Condition -->
      <div [style.display]="selectedChargeType === _chargeType.recurringCharge ? 'block' : 'none'" class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
          <mat-label>End Date Condition</mat-label>
          <mat-select (selectionChange)="onChangeEndDateCondition($event)" formControlName="endDateCondition" disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option *ngFor="let endDateCondition of collectionOfEndDateCondition" [value]="endDateCondition.value" class="custom-mat-option">{{ endDateCondition.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Billing Fixed Cycles -->
      <div *ngIf="selectedChargeType === _chargeType.recurringCharge && statusForEndCondition" class="form-row">
        <mat-form-field class="custom-mat-form-field field-price-model size size1of2">
          <mat-label>Up To Periods Type</mat-label>
          <mat-select formControlName="upToPeriodsType" required disableOptionCentering="true" panelClass="custom-mat-select-panel" class="custom-mat-select">
            <mat-option *ngFor="let upToPeriodsType of collectionOfUpToPeriodsType" [value]="upToPeriodsType.value" class="custom-mat-option">{{ upToPeriodsType.label }}</mat-option>
          </mat-select>
          <mat-error><error-messages [control]="form.get('upToPeriodsType')"></error-messages></mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="custom-mat-form-field size size1of2">
          <mat-label>Up To Periods</mat-label>
          <input matInput type="text" formControlName="upToPeriods" required placeholder="1" [cleave]="cleaveNumIntegerOptions">
          <mat-error><error-messages [control]="form.get('upToPeriods')"></error-messages></mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
